import React from "react";
import { ChakraProvider, Box, extendTheme } from "@chakra-ui/react";
import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import Navbar from "./components/Navbar";
import Home from "./pages/Home";
import AboutUs from "./pages/AboutUs"; // <-- merged page
import ServicesDesign from "./pages/ServicesDesign";
import ServicesSupplyChain from "./pages/ServicesSupplyChain";
import ServicesEpcManagement from "./pages/ServicesEpcManagement";
import ServicesConsultancy from "./pages/ServicesConsultancy";
import ServicesFeasibility from "./pages/ServicesFeasibility";
import ServicesAdvisory from "./pages/ServicesAdvisory";
import Projects from "./pages/Projects";
import Careers from "./pages/Careers";
import Contact from "./pages/Contact";
import Footer from "./components/Footer";

const theme = extendTheme({
  styles: {
    global: {
      body: { bg: "#F5FAF6", color: "#305D24" },
    },
  },
  colors: {
    brand: {
      primary: "#519C36",
      accent: "#F6A11A",
      light: "#F5FAF6",
      dark: "#305D24",
    },
  },
});

export default function App() {
  return (
    <ChakraProvider theme={theme}>
      <Router>
        <Navbar />
        <Box as="main" minH="100vh" bg="#F5FAF6">
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/about" element={<AboutUs />} />{" "}
            {/* merged About page */}
            <Route path="/services/design" element={<ServicesDesign />} />
            <Route
              path="/services/supply-chain"
              element={<ServicesSupplyChain />}
            />
            <Route
              path="/services/epc-management"
              element={<ServicesEpcManagement />}
            />
            <Route
              path="/services/consultancy"
              element={<ServicesConsultancy />}
            />
            <Route
              path="/services/feasibility-study"
              element={<ServicesFeasibility />}
            />
            <Route path="/services/advisory" element={<ServicesAdvisory />} />
            <Route path="/projects" element={<Projects />} />
            <Route path="/careers" element={<Careers />} />
            <Route path="/contact" element={<Contact />} />
          </Routes>
        </Box>
        <Footer />
      </Router>
    </ChakraProvider>
  );
}
